import { render, staticRenderFns } from "./CommonTextWithCardsBlock.vue?vue&type=template&id=fdba4ffc&scoped=true&"
import script from "./CommonTextWithCardsBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonTextWithCardsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTextWithCardsBlock.vue?vue&type=style&index=0&id=fdba4ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdba4ffc",
  null
  
)

export default component.exports